import { Box } from '@chakra-ui/react';

import { DEFAULT_SATURATION_BORDER_COLOR, SATURATION_BORDER_THICKNESS } from '../ColorPicker.config';
import { Color } from '../ColorPicker.types';
import {
  COLOR_DISPLAY_WIDTH,
  SATURATION_BORDER,
  SATURATION_BORDER_RADIUS,
  SATURATION_HEIGHT,
} from './ColorDisplay.constants';

interface ColorDisplayProps {
  color: Color;
  borderColor?: Color;
  h?: string;
  w?: string;
}
export const ColorDisplay = ({ color, borderColor, w, h }: ColorDisplayProps) => (
  <Box
    borderTop={SATURATION_BORDER}
    borderBottom={SATURATION_BORDER}
    borderLeft={SATURATION_BORDER}
    borderTopLeftRadius={SATURATION_BORDER_RADIUS}
    borderBottomLeftRadius={SATURATION_BORDER_RADIUS}
    borderColor={DEFAULT_SATURATION_BORDER_COLOR}
    boxShadow={
      borderColor
        ? `-${SATURATION_BORDER_THICKNESS / 2}px 0 0 ${
            SATURATION_BORDER_THICKNESS / 2
          }px ${borderColor}, 0 ${SATURATION_BORDER_THICKNESS}px 0 ${borderColor}, 0 -${SATURATION_BORDER_THICKNESS}px 0 ${borderColor}`
        : `none`
    }
    backgroundColor={color}
    w={w || `${COLOR_DISPLAY_WIDTH}px`}
    h={h || `${SATURATION_HEIGHT}px`}
  />
);
